<template>
  <div class="outgoing-detail" v-if="detail != null">
    <Toast />

    <div class="card">
      <h5>
        <b v-if="detail.summary.type == 'TRANSFER ITEM'"
          >Detail Transfer Item</b
        >
        <b v-else>Detail Transfer Barang</b>
      </h5>
      <div class="p-grid">
        <div class="p-col p-mb-5">
          <label for="">Nomor Bon</label>
          <div>{{ detail.summary.doc_number }}</div>
        </div>
        <div class="p-col p-mb-5">
          <label for="">Asal Gudang</label>
          <div>{{ detail.summary.warehouse_name }}</div>
        </div>

        <div class="p-col p-mb-5">
          <label for="">Tanggal Bon</label>
          <div>{{ moment(detail.summary.doc_date).format('DD-MM-YYYY') }}</div>
        </div>
        <div class="p-col p-mb-5">
          <label for="">Status</label>
          <div
            v-if="detail.summary.status_destination === 0"
            style="color: red"
          >
            <b>Pending</b>
          </div>
          <div
            v-if="detail.summary.status_destination === 1"
            style="color: green"
          >
            <b>Completed</b>
          </div>
        </div>

        <div class="p-col-12">
          <table class="table table-responsive">
            <thead class="thead-light">
              <tr>
                <th>No</th>
                <th>Kode Barang</th>
                <th>Nama Barang</th>
                <th>Kode Kategori</th>
                <th>Kode Supplier</th>
                <th>Harga</th>
                <th>Jumlah</th>
                <th>Total Harga</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(an_item, k) in detail.items" :key="k">
                <td>{{ k + 1 }}</td>
                <td>{{ an_item.item_code }}</td>
                <td>{{ an_item.item_name }}</td>
                <td>{{ an_item.category_code }}</td>
                <td>{{ an_item.supplier_code }}</td>
                <td>{{ an_item.price | currency }}</td>
                <td>{{ an_item.qty }}</td>
                <td>{{ an_item.total_price | currency }}</td>
                <td>
                  <Button
                    class="btn btn-primary"
                    v-if="an_item.status_destination === 0"
                    @click="onCompleteBtnClick(an_item)"
                  >
                    Complete
                    <!-- <span v-if="loading_approve">
                      <i
                        class="pi pi-spin pi-spinner"
                        style="fontsize: 12px"
                      ></i>
                    </span> -->
                  </Button>
                </td>
              </tr>
              <tr>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td v-if="detail.summary.type != 'TRANSFER ITEM'"></td>
                <td class="p-text-left">
                  <label for="">Total</label>
                </td>
                <td>{{ detail.summary.total_qty }}</td>
                <td>{{ detail.summary.total_price | currency }}</td>
                <td></td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="p-grid p-justify-left">
        <div class="p-col-6 p-md-6 p-lg-3">
          <button
            type="button"
            class="btn btn-primary"
            style="width: 100%"
            @click="confirmDialog = true"
            :disabled="loading.createButton"
          >
            Confirm
            <span v-if="loading.createButton">
              <i class="pi pi-spin pi-spinner" style="fontsize: 12px"></i>
            </span>
          </button>
        </div>
        <div
          class="p-col-6 p-md-6 p-lg-3"
          v-if="
            user.role == 'RETURN' &&
            'MAIN_PURCHASING' &&
            detail.summary.status == 1
          "
        >
          <button
            type="button"
            class="btn btn-primary"
            style="width: 100%"
            @click="printPage()"
          >
            Print
          </button>
        </div>
        <div
          class="p-col-6 p-md-6 p-lg-3"
          v-if="(user.role == 'RETURN' && detail.summary.status == 1) || 2"
        >
          <button
            type="button"
            class="btn btn-primary"
            style="width: 100%"
            @click="getOutletOutgoingCSV()"
          >
            Export
          </button>
        </div>
      </div>
    </div>
    <Dialog
      :visible.sync="completeDialog"
      :style="{ width: '450px' }"
      header="Confirm"
      :modal="true"
    >
      <div class="confirmation-content">
        <i class="pi pi-exclamation-triangle p-mr-3" style="font-size: 2rem" />
        <span> Apakah kamu yakin ingin mengkonfirmasi ? </span>
      </div>
      <template #footer>
        <Button
          type="button"
          label="Yes"
          icon="pi pi-check "
          class="btn btn-primary"
          @click="CompleteTransfer()"
        >
          Complete
          <span v-if="loading_approve">
            <i class="pi pi-spin pi-spinner" style="fontsize: 12px"></i>
          </span>
        </Button>
      </template>
    </Dialog>
    <Dialog
      :visible.sync="confirmDialog"
      :style="{ width: '450px' }"
      header="Confirm"
      :modal="true"
    >
      <div class="confirmation-content">
        <i class="pi pi-exclamation-triangle p-mr-3" style="font-size: 2rem" />
        <span> Apakah kamu yakin ingin mengkonfirmasi ? </span>
      </div>
      <template #footer>
        <Button
          type="button"
          label="Yes"
          icon="pi pi-check "
          class="btn btn-primary"
          @click="ApproveTransfer()"
        >
          APPROVE
          <span v-if="loading_approve">
            <i class="pi pi-spin pi-spinner" style="fontsize: 12px"></i>
          </span>
        </Button>
      </template>
    </Dialog>
    <Dialog
      :visible.sync="denyDialog"
      :style="{ width: '450px' }"
      header="Confirm"
      :modal="true"
    >
      <div class="confirmation-content">
        <i class="pi pi-exclamation-triangle p-mr-3" style="font-size: 2rem" />
        <span> Apakah kamu yakin ingin mengkonfirmasi ? </span>
      </div>
      <template #footer>
        <Button
          type="button"
          label="Yes"
          icon="pi pi-check "
          class="btn btn-primary"
          @click="DenyTransfer()"
        >
          Deny
          <span v-if="loading_approve">
            <i class="pi pi-spin pi-spinner" style="fontsize: 12px"></i>
          </span>
        </Button>
      </template>
    </Dialog>

    <!--  -->
  </div>
</template>

<script>
import { mapState } from 'vuex'

var moment = require('moment')
export default {
  data() {
    return {
      moment: moment,
      loading: true,
      products: null,
      loading_approve: false,
      expandedRows: [],
      detail: null,
      confirmDialog: false,
      completeDialog: false,
      denyDialog: false,
      outlet_inbound_data: null
    }
  },
  computed: mapState(['user', 'isAuthenticated']),
  mounted() {
    this.getTransfer()
  },
  methods: {
    onCompleteBtnClick(outlet_inbound) {
      this.outlet_inbound_data = outlet_inbound
      this.completeDialog = true
    },
    onDenyBtnClick(outlet_inbound) {
      this.outlet_inbound_data = outlet_inbound
      this.denyDialog = true
    },

    getOutletOutgoingCSV() {
      this.$http
        .get(
          `${process.env.VUE_APP_API_URL}/dashboard/outlet-outbounds/csv?doc_number=${this.$route.query.doc_number}`,
          {},
          { responseType: 'blob' }
        )
        .then(response => {
          if (response.status === 200) {
            let blob = new Blob([response.data], {
              type: response.headers['content-type']
            })
            let link = document.createElement('a')
            link.href = window.URL.createObjectURL(blob)
            link.download = `${this.detail.summary.doc_number}.csv`
            link.click()
          }
        })
    },
    getOutletOutgoingTrasnferSCV() {
      this.$http
        .get(
          `${process.env.VUE_APP_API_URL}/dashboard/transfer-item/csv?doc_number=${this.$route.query.doc_number}`,
          {},
          { responseType: 'blob' }
        )
        .then(response => {
          if (response.status === 200) {
            let blob = new Blob([response.data], {
              type: response.headers['content-type']
            })
            let link = document.createElement('a')
            link.href = window.URL.createObjectURL(blob)
            link.download = `${this.detail.summary.doc_number}.csv`
            link.click()
          }
        })
    },
    printPage() {
      this.$router.push({
        name: 'print-retur-bon',
        params: { detail: this.detail }
      })
    },
    getTransfer() {
      this.$http
        .get(
          `${process.env.VUE_APP_API_URL}/dashboard/warehouse-outbounds/transfer/detail?doc_number=${this.$route.query.doc_number}&destination=true`
        )
        .then(response => {
          if (response.status === 200) {
            this.detail = response.data.data
            // this.outlet_inbound_data = response.data.data.items.id
            for (let i = 0; i < this.detail.items.length; i++) {
              if (
                this.detail.items[i].status_destination == 0 &&
                this.detail.items[i].received_at != '' &&
                this.detail.items[i].received_by != '' &&
                i == this.detail.items.length - 1
              ) {
                this.detail.summary.status_destination = 2
              }
            }
          } else {
            // console.error('gagal get')
          }
        })
    },

    CompleteTransfer() {
      this.loading_approve = true
      this.$http
        .patch(
          `${process.env.VUE_APP_API_URL}/dashboard/warehouse-outbounds/transfer/receive/${this.outlet_inbound_data.id}`
        )
        .then(response => {
          this.completeDialog = false
          this.loading_approve = false
          if (response.status === 200) {
            this.$toast.add({
              severity: 'success',
              summary: 'Transfer Success',
              detail: 'Konfirmasi berhasil',
              life: 3000
            })
            this.completeDialog = false
            this.getTransfer()
          } else {
            this.$toast.add({
              severity: 'error',
              summary: 'Transfer Failed',
              detail: 'konfirmasi gagal',
              life: 3000
            })
          }
        })
    },

    ApproveTransfer() {
      this.loading_approve = true
      this.$http
        .patch(
          `${process.env.VUE_APP_API_URL}/dashboard/warehouse-outbounds/transfer/approve/${this.outlet_inbound_data.id}`
        )
        .then(response => {
          this.confirmTransferDialog = false
          this.loading_approve = false
          if (response.status === 200) {
            this.$toast.add({
              severity: 'success',
              summary: 'Transfer Success',
              detail: 'Konfirmasi berhasil',
              life: 3000
            })
            this.confirmDialog = false
            this.getTransfer()
          } else {
            this.$toast.add({
              severity: 'error',
              summary: 'Transfer Failed',
              detail: 'konfirmasi gagal',
              life: 3000
            })
          }
        })
    },
    DenyTransfer() {
      this.loading_approve = true
      this.$http
        .patch(
          `${process.env.VUE_APP_API_URL}/dashboard/warehouse-outbounds/transfer/deny/${this.outlet_inbound_data.id}`
        )
        .then(response => {
          this.confirmTransferDialog = false
          this.loading_approve = false
          if (response.status === 200) {
            this.$toast.add({
              severity: 'success',
              summary: 'Penolakan Success',
              detail: 'Konfirmasi berhasil',
              life: 3000
            })
            this.denyDialog = false
            this.getTransfer()
          } else {
            this.$toast.add({
              severity: 'error',
              summary: 'Penolakan Failed',
              detail: 'konfirmasi gagal',
              life: 3000
            })
          }
        })
    }
  }
}
</script>

<style scoped lang="scss">
/deep/ .p-progressbar {
  height: 0.5rem;
  background-color: #d8dadc;
  .p-progressbar-value {
    background-color: #607d8b;
  }
}
.p-datatable .p-column-filter {
  display: none;
}
.table-header {
  display: flex;
  justify-content: space-between;
}
/deep/ .p-datatable.p-datatable-outlets {
  .p-datatable-header {
    padding: 1rem;
    text-align: left;
    font-size: 1.5rem;
  }
  .p-paginator {
    padding: 1rem;
  }
  .p-datatable-thead > tr > th {
    text-align: left;
  }
  .p-datatable-tbody > tr > td {
    cursor: auto;
  }
  .p-dropdown-label:not(.p-placeholder) {
    text-transform: uppercase;
  }
}
/* Responsive */
.p-datatable-outlets .p-datatable-tbody > tr > td .p-column-title {
  display: none;
}
.customer-badge {
  border-radius: 2px;
  padding: 0.25em 0.5rem;
  text-transform: uppercase;
  font-weight: 700;
  font-size: 12px;
  letter-spacing: 0.3px;
  &.status-qualified {
    background: #c8e6c9;
    color: #256029;
  }
  &.status-unqualified {
    background: #ffcdd2;
    color: #c63737;
  }
  &.status-negotiation {
    background: #feedaf;
    color: #8a5340;
  }
  &.status-new {
    background: #b3e5fc;
    color: #23547b;
  }
  &.status-renewal {
    background: #eccfff;
    color: #694382;
  }
  &.status-proposal {
    background: #ffd8b2;
    color: #805b36;
  }
}
.p-progressbar-value.ui-widget-header {
  background: #607d8b;
}
@media (max-width: 640px) {
  .p-progressbar {
    margin-top: 0.5rem;
  }
}
.product-image {
  width: 100px;
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23);
}
.orders-subtable {
  padding: 1rem;
}
.product-badge {
  border-radius: 2px;
  padding: 0.25em 0.5rem;
  text-transform: uppercase;
  font-weight: 700;
  font-size: 12px;
  letter-spacing: 0.3px;
  &.status-instock {
    background: #c8e6c9;
    color: #256029;
  }
  &.status-outofstock {
    background: #ffcdd2;
    color: #c63737;
  }
  &.status-lowstock {
    background: #feedaf;
    color: #8a5340;
  }
}
input:disabled {
  color: black;
}
.order-badge {
  border-radius: 2px;
  padding: 0.25em 0.5rem;
  text-transform: uppercase;
  font-weight: 700;
  font-size: 12px;
  letter-spacing: 0.3px;
  &.order-delivered {
    background: #c8e6c9;
    color: #256029;
  }
  &.order-cancelled {
    background: #ffcdd2;
    color: #c63737;
  }
  &.order-pending {
    background: #feedaf;
    color: #8a5340;
  }
  &.order-returned {
    background: #eccfff;
    color: #694382;
  }
}
@media screen and (max-width: 960px) {
  /deep/ .p-datatable {
    &.p-datatable-outlets {
      .p-datatable-thead > tr > th,
      .p-datatable-tfoot > tr > td {
        display: none !important;
      }
      .p-datatable-tbody > tr {
        > td {
          text-align: left;
          display: block;
          border: 0 none !important;
          width: 100% !important;
          float: left;
          clear: left;
          border: 0 none;
          .p-column-title {
            padding: 0.4rem;
            min-width: 30%;
            display: inline-block;
            margin: -0.4rem 1rem -0.4rem -0.4rem;
            font-weight: bold;
          }
          .p-progressbar {
            margin-top: 0.5rem;
          }
        }
      }
    }
  }
}
</style>
